/**
 * 再入荷通知アプリの配置変更スクリプト（デバッグログ付き）
 *
 * 動作概要:
 * 1. ページ読み込み後、アプリの要素(#pricey-back-in-stock-shadow-host)を監視する。
 * 2. 要素が見つかったら、カートボタン(.product-form__submit)の下に移動させる。
 * 3. Shadow DOM内のスタイルを上書きし、固定表示を解除して自然な配置にする。
 * 4. 商品にタグ「label__販売終了」が付いている場合は再入荷通知を display:none で非表示にする。
 *
 * 本番でログが不要な場合は console.log 行を削除またはコメントアウトすること。
 */
(function () {
  console.log('--- 再入荷通知移動スクリプト: 開始 ---');

  // 監視対象のアプリID
  const appHostId = 'pricey-back-in-stock-shadow-host';
  // 移動先のターゲット（カートボタン/入荷待ちボタン）のクラス名
  const targetSelector = '.product-form__submit';

  // スタイルの上書き定義
  const customStyles = `
    .pricey-shop-app-extension-container {
      position: static !important;
      width: 100% !important;
      margin-top: 10px !important;
      display: flex !important;
      justify-content: center !important;
      background: transparent !important;
      box-shadow: none !important;
    }
    .pricey-shop-app-fab-button {
      width: 100% !important;
      border-radius: 4px !important;
      position: relative !important;
      inset: auto !important;
      transform: none !important;
    }
    .pricey-shop-app-fab-button-container {
      position: static !important;
      inset: auto !important;
      width: 100% !important;
    }
    .pricey-shop-app-fab-button-container>div {
    box-sizing: border-box !important;
    }
  `;

  /**
   * 再入荷通知アプリ要素をカートボタン直下に移動し、Shadow DOM 内スタイルを上書きする
   */
  function moveAppElement() {
    const appHost = document.getElementById(appHostId);
    const targetButton = document.querySelector(targetSelector);

    // デバッグ用ログ
    if (!appHost) {
      console.log('検索中...: アプリの要素(' + appHostId + ')が見つかりません。');
    }
    if (!targetButton) {
      console.warn('警告: 移動先のボタン(' + targetSelector + ')が見つかりません。');
    }

    if (!appHost || !targetButton) {
      return;
    }

    // 販売終了商品（label__販売終了タグ付き）の場合は再入荷通知を非表示
    var productForm = targetButton.closest('form[data-product-discontinued]');
    if (productForm && productForm.getAttribute('data-product-discontinued') === 'true') {
      appHost.style.display = 'none';
      return;
    }
    appHost.style.display = '';

    // すでに移動済みかチェック（無限ループ防止）
    if (targetButton.nextElementSibling === appHost) {
      return;
    }

    console.log('移動実行: アプリをボタンの下へ移動させます。');

    // 1. 要素をターゲットの下に移動
    targetButton.insertAdjacentElement('afterend', appHost);

    // 2. Shadow DOM内のスタイルを上書き
    if (appHost.shadowRoot) {
      if (!appHost.shadowRoot.querySelector('#custom-move-styles')) {
        const styleTag = document.createElement('style');
        styleTag.id = 'custom-move-styles';
        styleTag.textContent = customStyles;
        appHost.shadowRoot.appendChild(styleTag);
        console.log('成功: スタイルを適用しました。');
      }
    } else {
      console.warn('注意: ShadowRootが見つかりません。スタイルが適用できない可能性があります。');
    }
  }

  /**
   * MutationObserver で DOM 変化を監視し、アプリ出現時に移動処理を実行する
   */
  function initStockAlertMover() {
    moveAppElement(); // 初回チェック

    const observer = new MutationObserver(function () {
      moveAppElement();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    console.log('監視を開始しました（アプリが表示されるのを待機中）...');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStockAlertMover);
  } else {
    initStockAlertMover();
  }
})();
